import type { InsertBlockPluginOptions } from '@atlaskit/editor-plugin-insert-block/types';

export function insertBlockPluginOptions(): InsertBlockPluginOptions {
	return {
		allowTables: true,
		allowExpand: true,
		horizontalRuleEnabled: true,
		tableSelectorSupported: true,
		nativeStatusSupported: true,
		showElementBrowserLink: true,
		appearance: 'full-page',
	};
}
